import { wGroupIndicesATGeometry } from 'components/AgentTemplateEditView/menu/geometry';
import { IColumn } from 'components/general/types';
import EntityTableSegment from 'components/general/wizards/EntityTableSegment';
import { useActiveEntities } from 'hooks';
import { array2String } from 'utils/strings';
import BodyFrameVectorDialog from './BodyFrameVectorDialog';

const guidance = {
  heading: 'Create and Edit Body Frame Vectors',
  body: [
    {
      chunk:
        'Body Frame Vectors are fundamental to building up a physical model of your satellite.',
    },
    {
      subHeading: 'Links to Modeling',
      chunk:
        'Body Frame Vectors are used to drive Pointing Modes, define the orientation of sensor boresights and comm antennas, and to describe exterior geometry.',
    },
    {
      subHeading: 'Key Considerations',
      chunk:
        'Take care when establishing your principal directions and origin. If you have a CAD model of your satellite, align your Sedaro body frame with the coordinate system in the CAD model - this will make extracting key vectors straightforward.',
    },
  ],
};

const columns: IColumn[] = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Unit Vector',
    render: (rowData) => array2String(rowData.unitVector),
  },
];

const BodyFrameVectorSegment = () => {
  const { bodyFrameVectors } = useActiveEntities();

  return (
    <EntityTableSegment
      title="Body Frame Vectors"
      index={wGroupIndicesATGeometry.BODY_VECTORS}
      guidance={guidance}
      entityColumns={columns}
      entityData={bodyFrameVectors}
      DialogComponent={BodyFrameVectorDialog}
      modelName="body frame vector"
    ></EntityTableSegment>
  );
};

export default BodyFrameVectorSegment;
